import { Component, OnInit, Inject, Input } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { Router, NavigationExtras } from '@angular/router';
import { LocalDataSource, ViewCell } from 'ng2-smart-table';
import { NULL_EXPR } from '@angular/compiler/src/output/output_ast';


@Component({
  selector: 'modal-check-box-entidad-act',
  templateUrl: './modal-check-box-entidad-act.component.html',
  styleUrls: ['./modal-check-box-entidad-act.component.scss'],
  providers: [PeticionesHttpBackEndService, UtilidadesService],
})



export class ModalCheckBoxEntidadActComponent implements OnInit {
  nombre:any = "";
  apellidos:any = "";
  listActividadesEntidadesTipos:any;
  listActividadesEntidad:any;
  placeEmpresa:any = "Seleccione empresa";
  pagado:boolean = false;
  metodoPago:boolean = false;
  tipo:any;
  fechaPago:Date = new Date();
  seleccionadoPagago:any ="Seleccione";
  selectPagado: any; 
  listTipoPago:any = [];
  listEmpresas:any;
  listTipoPagoFilter:any = [];
  JsonObjectSalida:any;
  tipoPago:any = "Seleccione";
  desactivarEmpresa:boolean = false;
  dtoSalida ={
    object:[]
  };
  contador:number = 0;
  avisoPagado:boolean = false;
  listAforoCount:any;
  avisoActivo:boolean = false;
  constructor(private router:Router, public utilidades: UtilidadesService, public dialogRef: MatDialogRef<ModalCheckBoxEntidadActComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, public _PeticionesHttpBackEndService: PeticionesHttpBackEndService, private authService: NbAuthService) { 
     
  }

 
  ngOnInit() {
   this.nombre = this.data.entidad.Nombre;
   this.apellidos = this.data.entidad.Apellidos != undefined ? this.data.entidad.Apellidos : '';

  
   this._PeticionesHttpBackEndService.getAllReg("v1/actividadesEntidadesTipos").subscribe(
    result => {
      this.listActividadesEntidadesTipos = result;
      this.listActividadesEntidadesTipos = this.listActividadesEntidadesTipos.ActividadesEntidadesTipos;
      this._PeticionesHttpBackEndService.getActividadesById("v1/comprobarEntidadActividad",this.data.actividadId+'/'+this.data.entidad.EntidadId).subscribe(
        result => {
         this.listActividadesEntidad = result;
         this.listTipoPago = this.listActividadesEntidad.TipoPago;
         this.listAforoCount = this.listActividadesEntidad.AforoCount;
         this.listTipoPago.forEach(element => {
           if(element._tipo_pago_id != 3){
            this.listTipoPagoFilter.push(element);
           }
         });
         this.listActividadesEntidad = this.listActividadesEntidad.ActividadEntidad;
          for (var _i = 0; _i < this.listActividadesEntidadesTipos.length; _i++) {
            this.listActividadesEntidadesTipos[_i]["Activo"]=false;
            for (var _j = 0; _j < this.listActividadesEntidad.length; _j++) {
              if(this.listActividadesEntidad[_j]._actividad_entidad_tipo_id == this.listActividadesEntidadesTipos[_i]._actividad_entidad_tipo_id){
                this.listActividadesEntidadesTipos[_i]["Activo"]=true;

                  if(this.listActividadesEntidadesTipos[_i]._actividad_entidad_tipo_id == 3){
                    if(this.listActividadesEntidad[_j]._empresa_id != null || this.listActividadesEntidad[_j]._empresa_id != undefined){
                      this.desactivarEmpresa = true;
                      this.avisoEmpresa(true,this.listActividadesEntidad[_j]._empresa_id);
                    }
                    if(this.listActividadesEntidad[_j]._confirmacion_pago){
                      this.fechaPago = new Date(this.listActividadesEntidad[_j]._fecha_pago);
                      this.tipoPago = this.listActividadesEntidad[_j]._tipo_pago_id._descripcion;
                      if(this.tipoPago != ""){
                        this.avisoPagado = true;
                      }
                     }
                    this.seleccionadoPagago = this.listActividadesEntidad[_j]._confirmacion_pago ? "Confirmado" : "No aceptado";
                    this.selectPagado = this.seleccionadoPagago;
                    this.activarPago(this.listActividadesEntidad[_j]._confirmacion_pago);
                  }
              }
            }
          }
          for (var _i = 0; _i < this.listActividadesEntidadesTipos.length; _i++) {
            if(this.listActividadesEntidadesTipos[_i]["Activo"]){
              this.avisoActivo = true;
            }
          }
         
        
        },
        error => {
          this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar la información económica"+"","top-left");
        });
    },
    error => {
      this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar la tabla de actividades entidades"+"","top-left");
    });

  }

  close(){
    this.dialogRef.close();
  }
  toggle(id,event) {
    this.cambiarEstado(id,event.target.checked);
    this.avisoActivo = false;
    for (var _i = 0; _i < this.listActividadesEntidadesTipos.length; _i++) {
      if(this.listActividadesEntidadesTipos[_i]["Activo"]){
        this.avisoActivo = true;
      }
    }
    
      if(id == '3' && !event.target.checked){
        this.desactivarPago();
      }else if(id == '3' && event.target.checked){
        this.seleccionadoPagago = "Seleccione";
        if(this.listAforoCount != ""){
            let count = this.listAforoCount[0]["Aforo"] <= +this.listAforoCount[0]["countEntAct"];
            if(count){
              this.utilidades.notificationWarning("Info",""+"El Aforo esta completo, si desea continuar se añadira a la lista de espera"+"","top-left");
            }
        }
        if(this.selectPagado == '1'){
          this.activarPago(true);
        }else{
            this.activarPago(false);
        }
        
      }
  }

  cambiarEstado(id,bandera){
   
      for (var _i = 0; _i < this.listActividadesEntidadesTipos.length; _i++) {
        if(this.listActividadesEntidadesTipos[_i]._actividad_entidad_tipo_id == id){
          this.listActividadesEntidadesTipos[_i]["Activo"]=bandera;
        }
      }
  }

  activarPago(element){
      this.pagado = true;
      this.metodoPago = element;
  }
  desactivarPago(){
    this.pagado = false;
    this.metodoPago = false;
}

  onChange(event){
    if(event == '1'){
      this.metodoPago = true;
    }else{
      this.metodoPago = false;
    }
  }
  empresaSeleccionada:any;
  save(){
    this.listEmpresas
          if(this.avisoActivo){
          this.dtoSalida ={
            object:[]
          };
          for (var _i = 0; _i < this.listActividadesEntidadesTipos.length; _i++) {
            if(this.listActividadesEntidadesTipos[_i].Activo){
              this.dtoSalida.object.push({
                  "ActividadId":this.data.actividadId,
                  "EntidadId":this.data.entidad.EntidadId,
                  "ActividadEntidadTipoId":this.listActividadesEntidadesTipos[_i]._actividad_entidad_tipo_id,
                  "ConfirmacionDePago":(this.listActividadesEntidadesTipos[_i].Activo && this.listActividadesEntidadesTipos[_i]._actividad_entidad_tipo_id ==3) ? this.selectPagado : 0,
                  "FechaDePago":(this.listActividadesEntidadesTipos[_i].Activo && this.listActividadesEntidadesTipos[_i]._actividad_entidad_tipo_id ==3) ? this.fechaPago : null,
                  "TipoDePagoId":(this.listActividadesEntidadesTipos[_i].Activo && this.listActividadesEntidadesTipos[_i]._actividad_entidad_tipo_id ==3) ? this.tipo : null,
                  "EmpresaId":this.empresaSeleccionada != null ? this.empresaSeleccionada : null,
                  "AvisoEmpresaId":this.listActividadesEntidadesTipos[_i]._actividad_entidad_tipo_id ==3 && this.checkEmpresa ? true : false
              })
            }
          }
            this.JsonObjectSalida = {ActividadId:this.dtoSalida};
            this._PeticionesHttpBackEndService.insertaObjecto("agregarActividadEntidad",{Data:this.JsonObjectSalida}).subscribe( 
              result => {
                this.utilidades.notificationSuccess("Exito",""+"Se inserto correctamente"+"","top-left");
              },
              error => {
                this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al insertar los roles a las entidades"+"","top-left");
              }
            );
            this.dialogRef.close();
        }else{
          this.utilidades.notificationWarning("Info",""+"Debe rellenar los campos"+"","top-left");
        }
    
}
checkEmpresa:any;
toggleVisibility(e){
  this.placeEmpresa ="Seleccione empresa";
  this.checkEmpresa= e.target.checked;
  if(this.checkEmpresa){
    this._PeticionesHttpBackEndService.getAllReg("v1/getAllEmpresas").subscribe(
      result => {
        this.listEmpresas = result;
        this.listEmpresas = this.listEmpresas.Entidades;
       }, 
       error => {
          this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar la tabla de actividades entidades"+"","top-left");
      });
  }
}
avisoEmpresa(e,id:number){
  this.checkEmpresa= e;
  this.empresaSeleccionada = id;
  if(this.checkEmpresa){
    this._PeticionesHttpBackEndService.getAllReg("v1/getAllEmpresas").subscribe(
      result => {
        this.listEmpresas = result;
        this.listEmpresas = this.listEmpresas.Entidades;
      
        this.listEmpresas.forEach(element => {
          if(element._entidad_id == id){
            this.placeEmpresa = element._nombre_empresa_institucion;
          }
        });
        
       }, 
       error => {
          this.utilidades.notificationWarning("Error",""+"Ocurrio un problema al cargar la tabla de actividades entidades"+"","top-left");
      });
  }
}

}
